var _metadata, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 1280.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3684 12783 c143 -499 768 -2564 968 -3193 129 -407 278 -823 338 -941 23 -43 24 -49 11 -49 -22 0 -124 -70 -154 -106 -60 -70 -81 -142 -121 -399 -30 -193 -88 -265 -314 -385 -470 -252 -813 -517 -1114 -859 -1081 -1230 -1241 -2984 -402 -4391 377 -632 968 -1164 1634 -1471 408 -188 814 -296 1265 -339 159 -15 497 -12 676 5 1005 96 1924 591 2554 1377 433 539 695 1162 792 1878 26 193 26 707 0 900 -115 846 -464 1569 -1041 2159 -304 310 -583 516 -991 731 -288 152 -326 200 -371 467 -13 81 -29 165 -35 188 -24 89 -97 193 -149 215 -17 7 -30 16 -30 19 0 4 21 63 46 132 92 251 194 615 434 1556 178 695 630 2499 630 2513 0 7 -300 10 -902 10 l-903 0 -209 -833 c-115 -457 -212 -835 -215 -839 -4 -4 -119 370 -255 832 l-249 840 -949 0 c-899 0 -949 -1 -944 -17z m1466 -4448 c12 -19 30 -40 40 -45 22 -12 838 -13 1444 -3 l398 6 30 25 c28 24 29 24 43 6 52 -68 9 -234 -70 -274 -51 -25 -158 -24 -335 4 -246 37 -366 47 -612 46 -276 0 -446 -15 -697 -61 -227 -41 -314 -17 -356 100 -18 52 -19 127 -2 158 12 22 74 73 88 73 4 0 17 -16 29 -35z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.211ceb0ed10d41cb6dde02264a802341.svg";
export { ForwardRef as ReactComponent };